
/* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
var quickLinksDropdown = document.getElementById("quickLinksDropdown")
var jumpLinksDropdown = document.getElementById("jumpLinksDropdown")

var clickHandler1 = function () { 
    quickLinksDropdown.classList.toggle("showSection")
    const link1 = document.getElementById("dropdownNavAside")
    link1.classList.toggle("show")
}
var clickHandler2 = function () { 
    jumpLinksDropdown.classList.toggle("showSection")
    const link2 = document.getElementById("dropdownNavBottom")
    link2.classList.toggle("show")
}
if (quickLinksDropdown)
  quickLinksDropdown.addEventListener('click', clickHandler1)
if (jumpLinksDropdown)
  jumpLinksDropdown.addEventListener('click', clickHandler2)
// Add arrow icon next to li items(quick links)

  var ul = document.getElementById('dropdownNavAside');

if (ul) {
  var listItems= ul.getElementsByTagName('li');

  for (let i = 0; i <= listItems.length - 1; i++) {
      if (listItems[i].innerText) {
        listItems[i].insertAdjacentHTML( 'beforeend', `<svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
          <g fill="none" stroke="#006BB6" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10">
            <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
            <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
          </g>
        </svg>` );
      }

  }
}
